import styled from '@emotion/styled'
import Input from 'antd/lib/input'
import InputNumber from 'antd/lib/input-number'

export const StyledFormInput = styled(Input, {
  shouldForwardProp: (prop) => prop !== 'textAlign'
})<{
  textAlign?: 'left' | 'right' | 'center'
}>`
  height: 30px;
  width: 80px;
  border-radius: 4px;
  border: 1px solid #d2d2d9;
  padding: 8px;
  font-size: 12px !important;
  color: #4a4a68 !important;

  &.ant-input:focus,
  &:hover {
    border: 1px solid #4a4a68 !important;
    box-shadow: 0px 0px 0px 4px rgba(109, 118, 236, 0.2);
  }

  .ant-input-disabled,
  &.ant-input-disabled,
  &.ant-input-affix-wrapper-disabled,
  &.ant-input-affix-wrapper-disabled:hover {
    border: none !important;
    box-shadow: none !important;
    font-size: 12px !important;
    color: #4a4a68 !important;
    background-color: #f3f2f4 !important;
  }

  &.ant-input,
  .ant-input {
    font-weight: 400;
    font-size: 12px !important;
    line-height: 100% !important;
    letter-spacing: 0%;
    vertical-align: middle;
    font-family: 'Roboto', sans-serif;
    padding-right: 2px !important;
    text-align: ${({ textAlign }) => textAlign || 'left'};
    color: #4a4a68 !important;
  }

  .ant-input-suffix {
    font-weight: 500;
    font-size: 12px !important;
    line-height: 1 !important;
    letter-spacing: 0%;
    vertical-align: middle;
    padding: 0 0 0 4px;
    font-family: 'Roboto', sans-serif;
    color: #4a4a68 !important;
  }
`

export const StyledFormInputNumber = styled(InputNumber)`
  height: 30px;
  max-width: 80px;
  border-radius: 4px;
  border: 1px solid #d2d2d9;
  padding: 7px 12px 8px 12px;
  font-size: 12px !important;
  color: #4a4a68 !important;

  &.ant-input:focus,
  &:hover {
    border: 1px solid #4a4a68 !important;
    box-shadow: 0px 0px 0px 4px rgba(109, 118, 236, 0.2);
  }

  .ant-input-affix-wrapper-disabled.ant-input-affix-wrapper,
  .ant-input-number-input[disabled]::placeholder,
  &.ant-input-number-affix-wrapper-disabled,
  &.ant-input-affix-wrapper-disabled,
  &.ant-input-affix-wrapper-disabled:hover {
    border: none !important;
    box-shadow: none !important;
    font-size: 12px !important;
    color: #4a4a68 !important;
    background-color: #f3f2f4 !important;
    opacity: 0.8;
  }

  .ant-input-number {
    height: 16px;
    padding: 0;
    font-size: 12px !important;
    color: #4a4a68 !important;
  }

  .ant-input-number:hover {
    border: none !important;
    outline: none;
  }

  .ant-input-number input,
  .ant-input-number-prefix {
    font-weight: 400;
    font-size: 12px !important;
    line-height: 100% !important;
    letter-spacing: 0%;
    vertical-align: middle;
    font-family: 'Roboto', sans-serif;
    height: 16px;
    color: #4a4a68 !important;
  }

  .ant-input-number-prefix {
    position: relative;
    top: 0.125px;
  }

  .ant-input-number:hover {
    border: none;
    box-shadow: none;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }
`

export const StyledSearchInput = styled(Input)`
  height: 36px;
  border: 1px solid #dbd9df;
  border-radius: 4px;
  font-size: 16px;

  &:hover {
    border: 1px solid #4a4a68 !important;
    box-shadow: 0px 0px 0px 4px rgba(109, 118, 236, 0.2);
  }

  .ant-input-clear-icon {
    line-height: 1;
  }
`
